import React from 'react';
import { blogPosts } from '../mock';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function JournalSection() {
  return (
    <section id="journal" className="section" style={{ background: 'var(--sm-ivory)' }}>
      <div className="container-x">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginBottom: 56, gap: 32, flexWrap: 'wrap' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
              <span className="hairline" />
              <span className="overline">The Journal</span>
            </div>
            <h2 className="serif" style={{ fontSize: 'clamp(32px, 4vw, 52px)', lineHeight: 1.1, color: 'var(--sm-navy)', margin: 0 }}>
              Reflections on trade, travel, and giving back.
            </h2>
          </div>
          <a href="#" className="link-underline" style={{ fontSize: 12, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--sm-navy)', textDecoration: 'none', fontWeight: 600 }}>View All Articles</a>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }} className="journal-grid">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article style={{ display: 'flex', flexDirection: 'column', height: '100%', cursor: 'pointer' }}
                       onMouseEnter={(e) => { const img = e.currentTarget.querySelector('img'); if (img) img.style.transform = 'scale(1.06)'; }}
                       onMouseLeave={(e) => { const img = e.currentTarget.querySelector('img'); if (img) img.style.transform = 'scale(1)'; }}>
                <div style={{ overflow: 'hidden', aspectRatio: '4/3', marginBottom: 20, background: 'var(--sm-cream)' }}>
                  <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 700ms cubic-bezier(.2,.7,.2,1)' }} />
                </div>
                <div style={{ fontSize: 10, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold)', marginBottom: 10 }}>{post.category} · {post.date}</div>
                <h3 className="serif" style={{ fontSize: 20, lineHeight: 1.3, color: 'var(--sm-navy)', margin: 0, marginBottom: 12 }}>{post.title}</h3>
                <p style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--sm-muted)', margin: 0, marginBottom: 16 }}>{post.excerpt}</p>
                <div style={{ marginTop: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--sm-navy)', fontWeight: 600 }}>
                  Read More <ArrowUpRight size={14} />
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1100px) { .journal-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 600px) { .journal-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
